module.exports = __webpack_public_path__ + "img/couverture.1492da44.jpg";